module.exports = __webpack_public_path__ + "img/color-9.f0154bb.png";